import systemLogFilesService from '@/api/system-log-files-service';

const state = {
  systemLogFiles: [],
};

const mutations = {
  SET_SYSTEM_LOG_FILES(state, files) {
    state.systemLogFiles = files;
  },
};

const actions = {
  fetchSystemLogFiles({ commit }, params) {
    return systemLogFilesService.getFiles(params).then((res) => {
      commit('SET_SYSTEM_LOG_FILES', res.data);
      return res.data;
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
